export default __webpack_public_path__ + "static/media/ws.f06e3a39.svg";